export default "__VITE_ASSET__dAtgxsNO__"